import { CSSProperties, StyleSheet } from 'aphrodite';
import { baseStyles, CssSelectors, truncateTextStyle } from '../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		alignItems: 'center',
	},
	selectTrigger: {
		...(baseStyles.textField as CSSProperties),
		height: 30,
		maxWidth: 140,
	},
	selectOption: {
		...CssSelectors.allChildren(
			{
				...truncateTextStyle,
			},
			'.select-box-trigger-content'
		),
	},
	percentageLabel: {
		marginLeft: 8,
		fontWeight: 'bold',
	},
	modal: {
		width: 400,
	},
	modalContent: {
		padding: 20,
	},
	modalTitle: {
		marginTop: 0,
		marginBottom: 16,
		fontSize: 18,
		fontWeight: 'bold',
	},
	modalInstruction: {
		marginBottom: 16,
	},
	input: {
		width: '100%',
		padding: 8,
		marginBottom: 20,
		border: '1px solid #ddd',
		borderRadius: 4,
	},
	modalButtons: {
		alignItems: 'center',
		display: 'flex',
		flex: 2,
		flexDirection: 'row',
		margin: '12px 0',
		maxHeight: 35,
		...CssSelectors.allChildren(
			{
				marginLeft: 10,
			},
			':not(:first-child)'
		),
	},
	cancelButton: {
		padding: '8px 16px',
		marginRight: 10,
		border: '1px solid #ddd',
		backgroundColor: '#f5f5f5',
		borderRadius: 4,
		cursor: 'pointer',
	},
	submitButton: {
		padding: '8px 16px',
		backgroundColor: '#0078d4',
		color: 'white',
		border: 'none',
		borderRadius: 4,
		cursor: 'pointer',
	},
});
